<template>

	<div id="content" class="content join join_done">
		<div class="container">

			<div class="page-title">
				<h2 class="tit">NAVER 로그인 진행중</h2>
				<p class="sub-tit">NAVER 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>

		</div>
	</div>

</template>

<script>

import $ from 'jquery'

export default {
	name: "naverIOSReturn",
	data() {
		return {
			LOCAL: location.hostname,
		}
	},
	created() {
		var self = this;

		if (this.APIs.BASE_URL.indexOf('localhost') !== -1) {
			// 동적으로 현재 포트 사용
			self.APIs.KAKAO_IOS_LOGIN_RETURN = location.origin + '/member/sns/naverIOSReturn'
		}

		$.ajax({
			url: this.APIs.OAUTH + '/naver',
			type: "POST",
			data: {
				url: 'https://nid.naver.com/oauth2.0/token?'
						+ 'grant_type=' + 'authorization_code' + '&'
						+ 'client_id=' + this.APIs.NAVER_LOGIN_KEY + '&'
						+ 'client_secret=' + this.APIs.NAVER_LOGIN_SECRET + '&'
						+ 'code=' + new URL(window.location.href).searchParams.get("code") + '&'
						+ 'state=' + new URL(window.location.href).searchParams.get("state"),
				naverClientId: this.APIs.NAVER_LOGIN_KEY,
				naverClientSecret: this.APIs.NAVER_LOGIN_SECRET
			},
			success: function (r) {
				self.axiosCaller.get(self, self.APIs.SESSION + "/doSnsLogin", {
					snsService: "naver",
					snsId: r.result.response.id,
					deviceToken: (self.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
				}, async (res) => {

					const result = res.data;
					if (result.status === "ok") {
						if (await self.setSessionProc(result.coAccountVO)) {
							self.setSessionKeep(this.isKeepSession);
							self.goWithCoCode(self)
						}
					} else {
						self.swalUtils.gritter("Error", result.msg, "info", 1500)
					}
				})
			},
			error: function (e) {
				console.log(e)
			}
		})
	},
	mounted() {
		this.appDeviceToken("#deviceToken")
	},
	methods: {
		goReferrer() {
			if (!this.stringUtils.isEmpty(this.$route.query.referrer)) {
				console.log(this.$route.query.referrer)
				location.href = this.$route.query.referrer
			} else {
				location.href = "/"
			}
		},
	}
}

</script>

<style scoped>

</style>
